export default __webpack_public_path__ + "static/media/pes_barva-min.fbce7911.png";